import React from 'react';

const Disclaimer: React.FC = () => (
    <div className="disclaimer">
        <div className="text-center">
            Er kunnen geen rechten worden ontleend aan bovenstaande rentetarieven en voorwaarden.
        </div>
    </div>
);

export default Disclaimer;
